import { bookingStatus } from 'types/booking';

const NON_REFUND_FEE_OH = 'NON_REFUND_FEE_OH';
const USERNAME_CLEAN_UP = 'CLEAN_UP';

export const shouldShowExpiredOnHoldInfo = (status) => {
  if (!status) return false;
  return status === bookingStatus.CANCELLED || status === bookingStatus.REFUNDED;
};

export const checkForExpiredOnHoldBooking = (historyDetails) => {
  if (!historyDetails) return null;

  const latestRevisionWithCleanUp = historyDetails
    .filter((detail) => detail.username === USERNAME_CLEAN_UP)
    .sort((a, b) => b.revisionNumber - a.revisionNumber)[0];

  if (!latestRevisionWithCleanUp) return null;

  const segmentsByUuid = new Map();

  if (latestRevisionWithCleanUp.data?.bookingItemsActions) {
    latestRevisionWithCleanUp.data.bookingItemsActions.forEach((action) => {
      if (action.segments) {
        action.segments.forEach((segment) => {
          const uuid = segment.uuid;
          if (!segmentsByUuid.has(uuid)) {
            segmentsByUuid.set(uuid, {});
          }
          const existing = segmentsByUuid.get(uuid);

          if (segment.fees && segment.fees.length > 0) {
            existing.fees = segment.fees;
          }
          if (segment.requiredProducts && segment.requiredProducts.length > 0) {
            existing.requiredProducts = segment.requiredProducts;
          }
          if (segment.additionalProducts && segment.additionalProducts.length > 0) {
            existing.additionalProducts = segment.additionalProducts;
          }
        });
      }
    });
  }

  const segmentsWithNonRefundFees = [];
  segmentsByUuid.forEach((segment) => {
    if (segment.fees) {
      const hasNonRefundFee = segment.fees.some((fee) => fee.tariffCode === NON_REFUND_FEE_OH);
      if (hasNonRefundFee) {
        segmentsWithNonRefundFees.push(segment);
      }
    }
  });

  if (segmentsWithNonRefundFees.length === 0) return null;

  let totalTcnValue = 0;
  let totalDepositValue = 0;

  const firstFee = segmentsWithNonRefundFees[0]?.fees?.find((f) => f.currency);
  const currency = firstFee?.currency || 'GBP';

  segmentsWithNonRefundFees.forEach((segment) => {
    if (segment.fees) {
      segment.fees.forEach((fee) => {
        if (fee.tariffCode === NON_REFUND_FEE_OH) {
          totalDepositValue += fee.price || 0;
        }
      });
    }

    if (segment.requiredProducts) {
      totalTcnValue += segment.requiredProducts.reduce((sum, product) => sum + (product.price || 0), 0);
    }
    if (segment.additionalProducts) {
      totalTcnValue += segment.additionalProducts.reduce((sum, product) => sum + (product.price || 0), 0);
    }
  });

  const balance = totalTcnValue - totalDepositValue;

  return {
    totalTcnValue: Number(totalTcnValue.toFixed(2)),
    totalDepositValue: Number(totalDepositValue.toFixed(2)),
    balance: Number(balance.toFixed(2)),
    currency
  };
};
